import { ref } from "vue";

// Estado global para el snackbar (patrón singleton)
const show = ref(false);
const text = ref("");
const color = ref("success");
const timeout = ref(4000);

export function useSnackbar() {
   const showSnackbar = (newText, newColor = "success", newTimeout = 4000) => {
    text.value = newText;
    color.value = newColor;
    show.value = true;
    timeout.value = newTimeout;
   };

  // Exponemos el estado y la función para que puedan ser usados globalmente
  return { show, text, color, timeout, showSnackbar };
}
